/* eslint-disable import/extensions */
import { IdleQueue } from 'idlize/IdleQueue.mjs'

import tracker from '@titanio/tracker'
import navbar from '@magnetita/navbar'
import dropdown from '@magnetita/dropdown'
import ThirdParty from '@titanio/thirdparty'
import animation from '@modules/animation'
import Async3rdLoad from '@titanio/async-3rd-loader'

import leadTracking from '@modules/lead-tracking'
// eslint-disable-next-line import/no-extraneous-dependencies
import Header from '@foregon/header'
import expandableContent from '../components/expandable-content/expandable-content'

const loader = () => {
  const queue = new IdleQueue()

  setTimeout(() => tracker.mount(), 0)

  setTimeout(() => {
    const header = new Header()
    header.mount()
  }, 0)

  setTimeout(() => navbar.mount(), 0)
  setTimeout(() => dropdown.mount(), 0)

  setTimeout(() => animation.mount(), 0)
  setTimeout(() => expandableContent.mount(), 0)

  /**
   * one-tap-login | AsyncLoad
   */
  queue.pushTask(() => {
    try {
      fetch('/account/api/me')
        .then((x) => x.json())
        .then((data) => {
          if (!data.success) {
            import(
              /* webpackChunkName: "one-tap-login" */
              '@titanio/one-tap-login'
            ).then((module) => {
              const otsignin = module.default
              otsignin.mount()
            })
          }
        })
    } catch (err) {
      console.log(err)
    }
  })

  queue.pushTask(() => {
    leadTracking.mount()
  })

  queue.pushTask(() => {
    if (window.innerWidth >= '998') {
      import(
        /* webpackChunkName: "stickybits" */
        'stickybits'
      ).then((module) => {
        const stickybits = module.default
        stickybits('.js-stickybits', {
          stickyBitStickyOffset: 40,
        })
      })
    }
  })

  window.LazyLoad = ThirdParty
  window.AsyncModule = Async3rdLoad
}

export default { loader }
